/** Webchat domain query segments */
export const WebchatQueryKeys = {
  tokenStart: (payload: unknown) => ['webchat/token-start', payload] as const,
  guestStart: (payload: unknown) => ['webchat/guest-start', payload] as const,
  managerStart: (payload: unknown) => ['webchat/manager-start', payload] as const,
  principalStart: (idOrContext: unknown) => ['webchat/principal-start', idOrContext] as const,
  onsite: (assetUID: string, payload: unknown) => [`webchat/onsite/${assetUID}`, payload] as const,
  /** AI-translated webchat chrome strings (NS-2036), one cache entry per target locale. */
  aiTranslateUi: (targetLang: string) => ['webchat/ai-translate-ui', targetLang] as const,
  entityPreview: {
    task: (taskUid: string) => ['webchat/entity-preview/task', taskUid] as const,
    taskType: (uid: string) => ['webchat/entity-preview/task-type', uid] as const,
    asset: (uid: string) => ['webchat/entity-preview/asset', uid] as const,
    assetType: (uid: string) => ['webchat/entity-preview/asset-type', uid] as const,
    user: (uid: string) => ['webchat/entity-preview/user', uid] as const,
    org: (uid: string) => ['webchat/entity-preview/org', uid] as const,
  },
};
